export function makeMaxNumber<T>(maxNumber: number, errorMsg: T) {
  return (value?: string | number) => {
    const validatingValue = Number(value);

    if (validatingValue && validatingValue > maxNumber) {
      return errorMsg;
    }

    return undefined;
  };
}
